import { SlotData } from 'modules/kiosk/types/Slot';
import { KeyType } from 'modules/kiosk/types/GetReadySelfServices';
import { SelfServiceType } from 'modules/selfServices/types/SelfService';

import { KeyStatus, Kiosk } from './Kiosk';

export interface OpenKeysSafeRequest {
  kioskId: string;
  selfServiceId?: string;
  slotId?: string;
  token?: string;
  reopen?: boolean;
  emergency?: boolean;
  doorTimeout?: boolean;
}

/**
 * Public projection of a slot as returned by the API (mirrors the backend `PublicSlot`):
 * slot identity + its owning kiosk. It intentionally does NOT carry `status`/`finalized`
 * — those belong to the `AdminSlot` store entity and are only provided by `getKioskData`.
 * `selfServiceId` is added client-side (see `openSlot` `transformResponse`).
 */
export interface PublicSlot extends SlotData {
  id: string;
  currentKeyType?: KeyType;
  selfServiceId?: string;
  kiosk: Pick<Kiosk, 'id' | 'name'>;
}

export interface CloseKeysSafeRequest extends OpenKeysSafeRequest {
  status?: KeyStatus;
}

export interface KeysSafeAction {
  selfServiceId?: string;
  selfServiceType?: SelfServiceType;
  asAdmin?: boolean;
  emergency?: boolean;
  slotId?: string;
  keyStatus?: KeyStatus;
  keyType?: KeyType;
}

export interface CloseSafeAction extends KeysSafeAction {
  hasAccepted?: boolean;
}

export enum DoorsStatus {
  PENDING = 'PENDING',
  OPENED = 'OPENED',
  CLOSED = 'CLOSED',
  OPENING = 'OPENING',
  CLOSING = 'CLOSING',
}
